/**
 * The dark basemap under every Leaflet map: the Stays map, /explore, and the
 * admin Analytics live-trips map.
 *
 * These maps used CARTO's dark_all raster tiles without a key. CARTO stopped
 * serving keyless tiles on 2026-09-25, so every tile came back as an
 * "API KEY REQUIRED" image on every domain, localhost included (seen on
 * defera.app's Stays map, 2026-10-08). The maps now draw OpenFreeMap's dark
 * style (openfreemap.org), which is free for commercial use with no key and
 * no account. It is vector tiles, so it renders through MapLibre GL inside
 * Leaflet (src/components/maps/DarkBasemap.jsx).
 *
 * OpenFreeMap has no SLA. VITE_BASEMAP_STYLE_URL points the maps at any other
 * MapLibre style without a code change (VERCEL_ENV_VARS.md). Whichever
 * provider it is, its credit has to stay visible: the Leaflet attribution
 * control shows the style's own credit.
 */

export const OPENFREEMAP_DARK_STYLE = 'https://tiles.openfreemap.org/styles/dark';

/** The MapLibre style URL to draw: the override when one is set, else OpenFreeMap dark. */
export function basemapStyleUrl(override) {
  const url = typeof override === 'string' ? override.trim() : '';
  return url || OPENFREEMAP_DARK_STYLE;
}

export const DARK_BASEMAP_STYLE = basemapStyleUrl(import.meta.env.VITE_BASEMAP_STYLE_URL);
